import React, { useState, useEffect } from 'react';
import { StyleSheet, SafeAreaView, FlatList, View } from 'react-native';
import { Card, Provider } from 'react-native-paper';
import { useTheme } from '@react-navigation/native';
import { useAuthContext } from '../../hooks/useAuthContext';
import { useSignin } from '../../hooks/useSignIn';
import axios from 'axios';

// * Language 
import { useTranslation } from 'react-i18next';
import CustomLabel from '../../components/CustomLabel/CustomLabel';

const HomePageZero = () => {
  const { t } = useTranslation();

  const { colors } = useTheme()
  const styles = makeStyles(colors)
  const [data, setdata] = useState([])
  const { refreshSignIn } = useSignin(); 
  const { username, user, dispatch, clientApi } = useAuthContext();
  const [loading, setLoading] = useState(false)


  // * This is called from the useeffect and also from on refresh 
  const GetNews = async () => {
    setLoading(true)
    await axios.get(`${clientApi}api/Employee/NewsFeed`, {
      headers: { Authorization: `Bearer ${user.token}` },
      params: {
        username: username
      }
    })
      .then((response) => {
        console.log(response.data)
        setdata(response.data)
      })
      .catch((error) => {
        console.log(error.response.status);
        if (error.response.status === 401) {
          refreshSignIn(user, clientapi)
        }
        console.log(error.message)
      })
    setLoading(false)
  }

  const renderData = (item) => {
    let today = new Date();
    let itemDate = new Date(item.msgDate)
    return (
      <Provider>
        <Card
          style={styles.cardstyle}>
          <Card.Content>
            <View
              style={styles.row}>

              <CustomLabel
                value={item.newsFeedMessage}
                type='MINOR'
              />
              {itemDate.getDate() === today.getDate() &&
                <View
                  style={[
                    styles.circle,
                  ]} />
              }
            </View>
          </Card.Content>
        </Card >
      </Provider >
    )
  }

  useEffect(() => {
    const onGetNews = async () => {
      await GetNews()
    }
    onGetNews()
      .catch(console.error);
  }, [])

  return (
    <SafeAreaView style={styles.mainView}>
      <FlatList
        data={data}
        renderItem={({ item }) => {
          return renderData(item)
        }}
        // Enable this to get data on refresh from API
        onRefresh={() => GetNews()}
        refreshing={loading}
        keyExtractor={item => `${item.newsFeedMessage}`}
        ListEmptyComponent={
          loading ? null : (
            <View style={{ padding: 16, alignItems: "center" }}>
              <CustomLabel value={t("common:noAnnouncements")} type="MINORTITLE_MUTED"/>
            </View>
          )
        }
      />
    </SafeAreaView>
  )
}

const makeStyles = (colors) => StyleSheet.create({
  mainView: {
    flex: 1,
    padding: 2,
    marginTop: 5,
  },
  cardstyle: {
    padding: 0,
    margin: 5,
    borderRadius: 35,
    elevation: 3,
    shadowColor: colors.card_line,
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.1,
    shadowRadius: 5,
    backgroundColor: colors.background_card,
  },
  circle: {
    width: 15,
    height: 15,
    borderRadius: 15 / 2,
    backgroundColor: "red",
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});

export default HomePageZero; 